export default {
  en: {
    Profile: 'Profile',
    username: 'Username',
    firstname: 'First Name',
    lastname: 'Last Name',
    homeairport: 'Home airport (ICAO code)',
    profile: {
      emailconfirmationmissing: 'Your e-mail still needs to be confirmed. Please check your inbox and spam folder for the confirmation e-mail.',
      resendemailconfirmation: 'Resend confirmation mail',
      update: 'Update Profile',
    }
  },
  de: {
    Profile: 'Profil',
    username: 'Benutzername',
    firstname: 'Vorname',
    lastname: 'Nachname',
    homeairport: 'Heimatflughafen (ICAO-Code)',
    profile: {
      emailconfirmationmissing: 'Deine E-Mail muss noch bestätigt werden. Bitte überprüfe deinen Posteingang und Spam-Ordner auf die Bestätigungs-E-Mail.',
      resendemailconfirmation: 'Bestätigungs-E-Mail erneut senden',
      update: 'Profil aktualisieren',
    }
  },
  at: {
    Profile: 'Profil',
    username: 'Benutzername',
    firstname: 'Vorname',
    lastname: 'Nachname',
    homeairport: 'Heimatflughafen (ICAO-Code)',
    profile: {
      emailconfirmationmissing: 'Deine E-Mail muss noch bestätigt werden. Bitte überprüfe deinen Posteingang und Spam-Ordner auf die Bestätigungs-E-Mail.',
      resendemailconfirmation: 'Bestätigungs-E-Mail erneut senden',
      update: 'Profil aktualisieren',
    }
  },
  es: {
    Profile: 'Perfil',
    username: 'Nombre de usuario',
    firstname: 'Nombre',
    lastname: 'Apellido',
    homeairport: 'Aeropuerto de origen (código ICAO)',
    profile: {
      emailconfirmationmissing: 'Tu correo electrónico aún necesita ser confirmado. Por favor, revisa tu bandeja de entrada y carpeta de spam para el correo de confirmación.',
      resendemailconfirmation: 'Reenviar correo de confirmación',
    }
  },
  uk: {
    Profile: 'Профіль',
    username: 'Ім’я користувача',
    firstname: 'Ім’я',
    lastname: 'Прізвище',
    homeairport: 'Домашній аеропорт (код ICAO)',
    profile: {
      emailconfirmationmissing: 'Вашу електронну пошту ще потрібно підтвердити. Будь ласка, перевірте свою вхідну пошту та спам на наявність листа з підтвердженням.',
      resendemailconfirmation: 'Повторно надіслати лист з підтвердженням',
      update: 'Оновити профіль',
    }
  },
}
